import { useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";
import { fmtDate } from "@/pages/admin/util";
import { Loader2 } from "lucide-react";

export default function ContactEnquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.get("/contact-enquiries").then((r) => setItems(r.data.items)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-contact-page">
      <span className="eyebrow">Inbound</span>
      <h1 className="font-display text-[32px] lg:text-[40px] leading-[1.05] tracking-tight text-[#071A33] mt-2">Contact enquiries</h1>

      <div className="mt-6 admin-panel overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#F7F4ED] text-left text-[#475569] text-xs uppercase tracking-[0.15em]">
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3">Subject</th>
              <th className="px-4 py-3">Message</th>
              <th className="px-4 py-3">Created</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={5} className="px-4 py-8 text-center text-[#475569]"><Loader2 className="animate-spin inline" size={16}/></td></tr>}
            {!loading && items.length === 0 && <tr><td colSpan={5} className="px-4 py-8 text-center text-[#475569]">No contact enquiries yet.</td></tr>}
            {items.map((c) => (
              <tr key={c.id} className="border-t border-[#E2DCD0] align-top">
                <td className="px-4 py-3 font-medium text-[#071A33]">{c.name}</td>
                <td className="px-4 py-3 text-[#475569]">{c.email}</td>
                <td className="px-4 py-3 text-[#071A33]">{c.subject}</td>
                <td className="px-4 py-3 text-[#475569] max-w-md whitespace-pre-wrap">{c.message}</td>
                <td className="px-4 py-3 text-[#475569] whitespace-nowrap">{fmtDate(c.created_at, true)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
